module.exports = __webpack_public_path__ + "img/Maradona-2.125eb025.webp";